import { Controller } from "@hotwired/stimulus"

// The confirm screen's rows. Two jobs only: let the ask grow as it's reworded, and let a row be
// dropped. Dropping clears the row's fields as well as hiding it, so a removed ask can't be
// submitted by a hidden input that outlived its row.
export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.fieldTargets.forEach((f) => this.size(f))
  }

  grow(event) {
    this.size(event.target)
  }

  size(el) {
    el.style.height = "auto"
    el.style.height = `${el.scrollHeight}px`
  }

  drop(event) {
    const row = event.currentTarget.closest("li")
    if (!row) return
    row.querySelectorAll("input, textarea").forEach((el) => { el.value = ""; el.disabled = true })
    row.remove()
    this.renumber()
  }

  // Keep the visible numbering contiguous after a drop — a list that jumps 1, 3, 4 reads as a
  // bug rather than a deletion.
  renumber() {
    this.element.querySelectorAll(".laz-cf-num").forEach((el, i) => { el.textContent = i + 1 })
  }
}
